/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSubscriptionPhase } from './UserSubscriptionPhase';
import {
    UserSubscriptionPhaseFromJSON,
    UserSubscriptionPhaseFromJSONTyped,
    UserSubscriptionPhaseToJSON,
    UserSubscriptionPhaseToJSONTyped,
} from './UserSubscriptionPhase';

/**
 * 
 * @export
 * @interface UserSubscriptionsResponse
 */
export interface UserSubscriptionsResponse {
    /**
     * 
     * @type {Array<UserSubscriptionPhase>}
     * @memberof UserSubscriptionsResponse
     */
    phases: Array<UserSubscriptionPhase>;
    /**
     * The card the membership is charged to
     * @type {string}
     * @memberof UserSubscriptionsResponse
     */
    defaultPaymentMethodId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSubscriptionsResponse
     */
    cancelsAtPeriodEnd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSubscriptionsResponse
     */
    paymentVerified: boolean;
    /**
     * Why the last charge failed, when the membership is paused
     * @type {string}
     * @memberof UserSubscriptionsResponse
     */
    paymentFailureMessage?: string;
}

/**
 * Check if a given object implements the UserSubscriptionsResponse interface.
 */
export function instanceOfUserSubscriptionsResponse(value: object): value is UserSubscriptionsResponse {
    if (!('phases' in value) || value['phases'] === undefined) return false;
    if (!('cancelsAtPeriodEnd' in value) || value['cancelsAtPeriodEnd'] === undefined) return false;
    if (!('paymentVerified' in value) || value['paymentVerified'] === undefined) return false;
    return true;
}

export function UserSubscriptionsResponseFromJSON(json: any): UserSubscriptionsResponse {
    return UserSubscriptionsResponseFromJSONTyped(json, false);
}

export function UserSubscriptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSubscriptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'phases': ((json['phases'] as Array<any>).map(UserSubscriptionPhaseFromJSON)),
        'defaultPaymentMethodId': json['defaultPaymentMethodId'] == null ? undefined : json['defaultPaymentMethodId'],
        'cancelsAtPeriodEnd': json['cancelsAtPeriodEnd'],
        'paymentVerified': json['paymentVerified'],
        'paymentFailureMessage': json['paymentFailureMessage'] == null ? undefined : json['paymentFailureMessage'],
    };
}

export function UserSubscriptionsResponseToJSON(json: any): UserSubscriptionsResponse {
    return UserSubscriptionsResponseToJSONTyped(json, false);
}

export function UserSubscriptionsResponseToJSONTyped(value?: UserSubscriptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phases': ((value['phases'] as Array<any>).map(UserSubscriptionPhaseToJSON)),
        'defaultPaymentMethodId': value['defaultPaymentMethodId'],
        'cancelsAtPeriodEnd': value['cancelsAtPeriodEnd'],
        'paymentVerified': value['paymentVerified'],
        'paymentFailureMessage': value['paymentFailureMessage'],
    };
}

